import { render, staticRenderFns } from "./shipment-bill-header-info.vue?vue&type=template&id=9e604b00&scoped=true&"
import script from "./shipment-bill-header-info.vue?vue&type=script&lang=js&"
export * from "./shipment-bill-header-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e604b00",
  null
  
)

export default component.exports